import React, { useState } from "react";
import queryString from "query-string";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import EditOutlined from "@ant-design/icons/EditOutlined";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import { Popconfirm, Button, Row, Col, Input, DatePicker } from "antd";
import { push, reservedPush } from "ducks/router";
import moment from "moment";
import PaginatedTable from "components/UI/Table";
import CheckRoleElement from "components/UI/CheckRoleElement";
import "./styles.scss";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

const { Search } = Input;

type BasePaginatedListComponentProps = {};

class BasePaginatedListComponent extends React.Component<BasePaginatedListComponentProps> {
  constructor(props) {
    super(props);
    this.notInProgressExcel = "Xuất Excel";
    this.inProgressExcel = "Đang xuất ...";
    this.state = {
      exportExcelButtonText: this.notInProgressExcel,
    };
    this.ModalDetailForm = null;

    this.rootPath = "";

    this.searchField = "keyword";

    this.tableProps = {};

    this.excludeEditButtons = false;

    this._callGetPaginatedList = async () => {
      throw new Error("No implementation");
    };

    this._callDeleteItem = async (_id) => {
      throw new Error("No implementation");
    };

    this._onAddClick = this._onAddClick.bind(this);
    this._onExportClick = this._onExportClick.bind(this);
    this._getDetailPathName = this._getDetailPathName.bind(this);
    this._onNameClick = this._onNameClick.bind(this);
    this._onDetailModalClose = this._onDetailModalClose.bind(this);
    this._onSubmitSuccess = this._onSubmitSuccess.bind(this);
    this._getColumns = this._getColumns.bind(this);
    this._renderActionButtons = this._renderActionButtons.bind(this);
    this._getRootPath = this._getRootPath.bind(this);
    this._onSearch = this._onSearch.bind(this);
    this._onDelete = this._onDelete.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const locationState = location.state || {};
    if (
      location.pathname < prevProps.location.pathname &&
      locationState.require_reload
    ) {
      this._refPaginatedTable && this._refPaginatedTable.reload();
    }
  }

  _onChangePicker = (value) => {
    const { location, dispatch } = this.props;
    if (value) {
      let fDate = value[0];
      let tDate = value[1];
      let search = {
        from_date: fDate.format("YYYY-MM-DD"),
        to_date: tDate.format("YYYY-MM-DD"),
      };
      search = queryString.stringify(search);
      dispatch(
        push({
          ...location,
          search,
        })
      );
    } else {
      dispatch(
        push({
          location,
        })
      );
    }
  };

  _getRootPath() {
    if (this.rootPath) {
      return this.rootPath;
    }
    const { location } = this.props;
    const splitPathName = location.pathname.split("/");
    return `/${splitPathName[1]}`;
  }

  _onExportClick() {
    console.log(this.state);
    this.setState({ exportExcelButtonText: this.inProgressExcel }, async () => {
      await this._exportExcel();
      this.setState({ exportExcelButtonText: this.notInProgressExcel });
    });
  }
  _onAddClick() {
    console.log(this);
    const { dispatch } = this.props;
    const rootPath = this._getRootPath();
    dispatch(reservedPush(`${rootPath}/create`));
  }

  _onSearch(keyword) {
    const { dispatch, location } = this.props;
    const currParams = queryString.parse(location.search.replace("?", ""));
    const newParams = {
      ...currParams,
      [this.searchField]: keyword,
    };
    if (!keyword) {
      delete newParams[this.searchField];
    }
    delete newParams.page;
    let search = queryString.stringify(newParams);
    search = search ? `?${search}` : "";
    dispatch(
      push({
        ...location,
        search,
      })
    );
  }

  _gotoEditMode(id, state) {
    return (e) => {
      e && e.preventDefault();
      const { dispatch } = this.props;
      const rootPath = this._getRootPath();
      dispatch(reservedPush(`${rootPath}/edit/${id}`, state));
    };
  }
  _gotoViewMode(id) {
    return (e) => {
      e && e.preventDefault();
      const { dispatch } = this.props;
      const rootPath = this._getRootPath();
      dispatch(reservedPush(`${rootPath}/view/${id}`));
    };
  }

  _getDetailPathName(id) {
    const rootPath = this._getRootPath();
    return `${rootPath}/view/${id}`;
  }

  _onNameClick(id) {
    return (e) => {
      e && e.preventDefault();
      const { dispatch } = this.props;
      const rootPath = this._getRootPath();
      dispatch(reservedPush(`${rootPath}/view/${id}`));
    };
  }

  _onDetailModalClose(locationState) {
    const { dispatch } = this.props;
    const rootPath = this._getRootPath();
    dispatch(reservedPush(`${rootPath}`, locationState));
  }

  _onSubmitSuccess(modalMode, record) {
    if (modalMode === "create") {
      // this._onDetailModalClose({ require_reload: true });
      // this._refPaginatedTable && this._refPaginatedTable.reload();
      this._gotoEditMode(record.id || record._id, { require_reload: true })();
    } else {
      this._refPaginatedTable && this._refPaginatedTable.reload();
    }
  }

  _getColumns() {
    throw new Error("No implementation");
  }

  _onDelete(id) {
    return () => {
      this._callDeleteItem(id).then(() => {
        this._refPaginatedTable && this._refPaginatedTable.reload();
      });
    };
  }

  _renderActionButtons() {
    const { location } = this.props;
    const rootPath = this._getRootPath();
    const { keyword } = queryString.parse(location.search);
    const currParams = queryString.parse(location.search.replace("?", ""));

    let fromDate = currParams["from_date"]
      ? moment(currParams["from_date"])
      : "";
    let toDate = currParams["to_date"] ? moment(currParams["to_date"]) : "";
    console.log(this.includeExportExcelButton, "this.includeExportExcelButton");
    if (this.includeDateFilter) {
      return (
        <Row type="flex" justify="space-between" gutter={5} className="mb-2">
          <Col>
            <Row gutter={10}>
              <Col>
                <RangePicker
                  size="small"
                  format={dateFormat}
                  defaultValue={[fromDate, toDate]}
                  onChange={this._onChangePicker}
                />
              </Col>
              <Col>
                <Input.Search
                  size="small"
                  enterButton
                  onSearch={this._onSearch}
                  placeholder="Tìm kiếm..."
                  defaultValue={keyword}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            {this.includeExportExcelButton && (
              <Button onClick={this._onExportClick} size="small" type="primary">
                {this.state.exportExcelButtonText}
              </Button>
            )}{" "}
            {/* Add a space character */}
            {!this.excludeCreateButton && (
              <CheckRoleElement route={`${rootPath}/create`}>
                <Button
                  onClick={this._onAddClick}
                  size="small"
                  icon={<PlusOutlined />}
                  type="primary"
                >
                  Tạo mới
                </Button>
              </CheckRoleElement>
            )}
          </Col>
        </Row>
      );
    }
    return (
      <Row type="flex" justify="space-between" gutter={5} className="mb-2">
        <Col>
          <Search
            size="small"
            enterButton
            onSearch={this._onSearch}
            placeholder="Tìm kiếm..."
            defaultValue={keyword}
          />
        </Col>
        <Col>
          {this.includeExportExcelButton && (
            <Button onClick={this._onExportClick} size="small" type="primary">
              {this.state.exportExcelButtonText}
            </Button>
          )}{" "}
          {!this.excludeCreateButton && (
            <CheckRoleElement route={`${rootPath}/create`}>
              <Button
                onClick={this._onAddClick}
                size="small"
                icon={<PlusOutlined />}
                type="primary"
              >
                Tạo mới
              </Button>
            </CheckRoleElement>
          )}
        </Col>
      </Row>
    );
  }

  render() {
    const {
      match: {
        params: { id },
      },
      mode,
      checkedRolesData,
    } = this.props;

    const rootPath = this._getRootPath();

    let detailID = null;
    let showDetailModal = false;
    const ModalForm = this.ModalDetailForm;
    if (mode === "create") {
      showDetailModal = true;
    }
    if (id) {
      showDetailModal = true;
      detailID = id;
    }

    const columns = this._getColumns();

    if (
      !this.excludeEditButtons &&
      (!checkedRolesData ||
        checkedRolesData[`${rootPath}/edit/:id`] ||
        (this.allowDelete && checkedRolesData[`${rootPath}/delete`]))
    ) {
      columns.push({
        title: "",
        key: "action",
        width: 80,
        render: (text, record) => (
          <span>
            {!record.prevent_edit && (
              <CheckRoleElement route={`${rootPath}/edit/:id`}>
                <Button
                  ghost
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={this._gotoEditMode(record.id || record._id)}
                  size="small"
                />
              </CheckRoleElement>
            )}

            {this.allowDelete && (
              <CheckRoleElement route={`${rootPath}/delete`}>
                <Popconfirm
                  placement="topRight"
                  title="Bạn có chắc chắn muốn xoá không?"
                  onConfirm={this._onDelete(record.id || record._id)}
                  okText="Có"
                  cancelText="Không"
                >
                  <Button
                    style={{ marginLeft: 5 }}
                    ghost
                    type="danger"
                    icon={<DeleteOutlined />}
                    size="small"
                  />
                </Popconfirm>
              </CheckRoleElement>
            )}
          </span>
        ),
      });
    }

    return (
      <div className="card base-paginated-list">
        <div className="card-body">
          {this._renderActionButtons()}
          <PaginatedTable
            {...this.tableProps}
            sticky
            bordered
            ref={(ref) => (this._refPaginatedTable = ref)}
            columns={columns}
            callFetchingDataAsyncFunc={this._callGetPaginatedList}
            size="small"
          />
        </div>
        {showDetailModal && (
          <ModalForm
            {...this.props}
            visible={showDetailModal}
            id={detailID}
            onClose={this._onDetailModalClose}
            onSubmitSuccess={this._onSubmitSuccess}
            mode={mode}
            gotoViewMode={this._gotoViewMode(detailID)}
            gotoEditMode={this._gotoEditMode(detailID)}
          />
        )}
      </div>
    );
  }
}
export default BasePaginatedListComponent;
